import ApplicationDetailPage from "./ApplicationDetailPage";

export default ApplicationDetailPage;
